import { Divider, Row } from 'antd';
import { RowProps } from 'antd/lib/grid/row';
import { FC, ReactNode } from 'react';
import styled from 'styled-components';

interface ProgramSectionGroupProps {
  isHeader?: boolean;
  gutter?: RowProps['gutter'];
  children?: ReactNode;
}

export const ProgramSectionGroup: FC<ProgramSectionGroupProps> = ({
  isHeader,
  gutter,
  children,
}) => {
  return (
    <>
      <SectionGroup gutter={gutter} isHeader={isHeader}>
        {children}
      </SectionGroup>

      {isHeader && <Divider style={{ margin: 0 }} />}
    </>
  );
};

const SectionGroup = styled(Row)<{ isHeader?: boolean }>`
  padding: 16px;
  font-weight: ${props => (props.isHeader ? 600 : 'inherit')};
  font-size: ${props => (props.isHeader ? '16px' : 'inherit')};
`;
